import css from './Navigation.module.scss';
import {navLinks} from '../../config/config';
import {useEffect, useState} from "react";
import {gsap} from "gsap";
import {ScrollToPlugin} from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);

const Navigation = () => {
    const [scrollTop, setScrollTop] = useState(0);
    const [showMobile, setShowMobile] = useState(false);
    const [activeUrl, setActiveUrl] = useState('');

    const navigate = (url) => {
        setShowMobile(false)
        setActiveUrl(url)
        gsap.to(window, {duration: 0, scrollTo: {y: url, offsetY: 100}});
    }

    useEffect(() => {
        const handleScroll = event => setScrollTop(window.scrollY)
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    let headerClass = ''

    if (scrollTop >= document.documentElement.clientHeight - 40) headerClass = 'stick'
    else headerClass = ''

    return (
        <header id={css.Header} className={`${headerClass} drop-shadow-2xl drop-shadow-nfr-color-900/60 bg-nfr-color-100/70 dark:bg-nfr-color-900/70`}>
            <div className='max-w-7xl mx-auto h-full flex justify-between align-middle content-center ' style={{alignItems: "center"}}>
                <div className={css.Logo}>
                    <a href="/">
                        <pre>{"<Nahid/>"}</pre>
                    </a>
                </div>
                <nav className={`${showMobile ? 'mobile-nav' : ''} drop-shadow-xl bg-nfr-color-100/95 dark:bg-nfr-color-900/95 md:drop-shadow-none md:bg-transparent dark:md:bg-transparent`}>
                    <ul>
                        {navLinks && navLinks.map(({url, name}, i) => (
                            <li key={i}>
                                <button
                                    onClick={() => navigate(url)}
                                    className={activeUrl === url ? 'active text-[#ff9e1e] !font-bold' : ''}
                                >{name}</button>
                            </li>
                        ))}
                    </ul>
                </nav>
                <div className={`${css.menu} + ${showMobile ? 'open' : ''}`}>
                    <button onClick={() => setShowMobile(!showMobile)} className='hoverableLink'>
                        <div className='bg-nfr-color-900 dark:bg-nfr-color-100'></div>
                        <div className='bg-nfr-color-900 dark:bg-nfr-color-100'></div>
                        <div className='bg-nfr-color-900 dark:bg-nfr-color-100'></div>
                    </button>
                </div>
            </div>
        </header>
    );
}

export default Navigation;
